import { createAsyncThunk } from '@reduxjs/toolkit';
import { submitConnectSectionMagentoApiCall } from './connect-launch.api';
import { ConnectSectionRequest } from './connect-launch.interface';
import { StoreState } from "../../store/store.interface";
import { ActionStatus } from '../../common/constants/action-status';

export const submitConnectSection = createAsyncThunk(
  'connectLaunch/submitSection',
  async (requestBody: ConnectSectionRequest, thunkAPI) => {
    try {
      return await submitConnectSectionMagentoApiCall(requestBody);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }, {
  condition: ((_arg, {getState} )=>{
    const state = getState() as StoreState;
    return state.connectLaunchState.status !== ActionStatus.loading;
  })
});
